
<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div v-if="params.value == 'loading'" class="sloader"></div>
		<div v-else>
			{{
				!isNaN(params.value)
					? Number(params.value).toLocaleString("fr-FR")
					: params.value
			}}
		</div>
	</div>
</template>
                                  
                                  <script>
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
};
</script>
                                  
                                  <style scoped>
/* Optional styling */
</style>